import { DRAWER_TOGGLE, DRAWER_COLLAPSE } from '../constants/ActionTypes'

// Drawer Toggle
export const acDrawerToggle = () => ({ type: DRAWER_TOGGLE })

// Drawer Sections Collapse
export const acDrawerCollapse = section => ({ type: DRAWER_COLLAPSE, payload: section })